import { PubSub } from "@/shared/utils/pubSub";
import { useSubscribe } from "@/shared/utils/useSubscribe";

type Callback = () => void;

const openSearchAssistPubSub = new PubSub<Callback>();

export const publishOpenSearchAssist = openSearchAssistPubSub.publish;
export const useOnOpenSearchAssist = (callback: Callback) => useSubscribe(openSearchAssistPubSub, callback);
